module.exports = __webpack_public_path__ + "img/suwang-night.22f0987f.png";